
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28916",
  depVersions: {
  "payments-ui-app": "static-1.28916",
  "apollo-dlb": "static-3.98",
  "bend-plugin-arboretum": "static-1.2087",
  "client-types": "static-1.522",
  "crm_data": "static-4.93349",
  "data-fetching-client": "static-1.10170",
  "emoji-mart": "static-3.9",
  "enviro": "static-4.529",
  "foundations-components": "static-1.8846",
  "foundations-components-legacy": "static-1.1871",
  "head-dlb": "static-1.5344",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6125",
  "hs-test-utils": "static-1.8577",
  "hub-http": "static-1.6740",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.12024",
  "I18n": "static-7.1723",
  "jasmine-runner": "static-1.6993",
  "quartz": "static-1.7753",
  "raven": "static-3.6435",
  "react-dlb": "static-1.96",
  "react-stripe-js": "static-1.123",
  "react-utils": "static-2.5714",
  "reselect": "static-3.19",
  "stripe-js": "static-1.122",
  "ui-components-test-utils": "static-1.6161",
  "UIComponents": "static-3.8970",
  "usage-tracker-public": "static-1.7688",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38164",
  "cssUtils": "static-1.1158",
  "customer-data-objects": "static-1.8249",
  "FireAlarmUi": "static-1.4923",
  "foundations-assets": "static-1.5424",
  "foundations-theming": "static-1.5036",
  "graphql": "static-1.95",
  "hs-browser-apis": "static-1.16",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12331",
  "icons": "static-2.715",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3411",
  "payments-checkout-lib": "static-1.839",
  "property-translator": "static-1.5911",
  "quartz-config": "static-1.1531",
  "quartz-core": "static-1.6972",
  "quartz-i18n": "static-1.1428",
  "quartz-routing": "static-1.1183",
  "quartz-tracking": "static-1.1132",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17272",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "redux-thunk": "static-2.87",
  "redux-toolkit": "static-1.84",
  "ReduxMessenger": "static-2.10907",
  "rpc-client-utils": "static-1.5201",
  "sanitize-text": "static-1.8692",
  "SharedI18nStrings": "static-1.190",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5290",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11682",
  "ui-images": "static-2.1295",
  "usage-tracker-core": "static-1.7727",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4030",
  "quartz-webpack": "static-1.3977",
  "bend-plugin-quartz-routing": "static-1.831",
  "bender-build-tools": "static-1.3648",
  "crm_universal": "static-1.22807",
  "customer-data-email": "static-1.18732",
  "customer-data-ui-utilities": "static-1.10368",
  "dispatcher": "static-1.150",
  "frontend-preferences-client": "static-1.8458",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8293",
  "quick-fetch": "static-1.4265",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5115",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2752",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9959",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.120",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3253",
  "ui-fonts": "static-1.1286",
  "HeadJS": "static-2.836",
  "hs-test-utils-bend-plugin": "static-1.3688",
  "msw": "static-1.105",
  "msw-config": "static-1.41",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.440",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4840",
  "foundations-components-test-utils": "static-1.6329",
  "ui-addon-draggable": "static-3.5287",
  "commerce-billing-lib": "static-1.20611",
  "commerce-shared-components-lib": "static-1.19689",
  "commerce-tools-ui-lib": "static-1.11429",
  "crm-message-bus": "static-1.44254",
  "customer-data-objects-ui-components": "static-1.13571",
  "customer-data-properties": "static-1.53245",
  "growth-payments-core": "static-1.26622",
  "ui-addon-iframeable": "static-1.9615",
  "usage-tracker": "static-1.7877",
  "usage-tracker-container": "static-1.7867",
  "sassPrefix": "static-1.422",
  "inbound-db-properties-service-client": "static-1.4188",
  "foundations-theming-base": "static-1.4021",
  "bend-plugin-foundations-theming": "static-1.3519",
  "stylex": "static-1.48",
  "opentelemetry-fe-types": "static-1.335",
  "hub-http-janus": "static-1.919",
  "hubspotter-http": "static-1.5011",
  "mobile-manifest-mixins": "static-1.618",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.710",
  "quartz-auth": "static-1.1428",
  "quartz-head": "static-1.1418",
  "quartz-test": "static-1.1428",
  "trellis-components": "static-1.3272",
  "usage-tracker-session-replay": "static-1.5563",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.237",
  "web-vitals": "static-1.21",
  "immer": "static-1.107",
  "bend-plugin-chirp-manifest": "static-1.611",
  "chirp-fetch": "static-1.2435",
  "autolinker": "static-3.11",
  "sanitize": "static-1.5003",
  "FormUrlGenerator": "static-2.5249",
  "sequences-lib": "static-1.8868",
  "apollo-link-hub-http": "static-2.5124",
  "FileManagerCore": "static-1.40429",
  "FileManagerLib": "static-1.40570",
  "hubspot-apollo-client": "static-1.5411",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.793",
  "timezone-utils": "static-2.5761",
  "ui-gdpr-components": "static-1.10658",
  "react-dnd-compat": "static-1.5145",
  "stylex-utils": "static-1.190",
  "trellis-theming": "static-1.1576",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.85",
  "avatar-components": "static-1.3023",
  "crm-command-handler-types": "static-1.192",
  "hs-resources": "static-1.731",
  "onboarding-scopes": "static-1.6987",
  "pulse": "static-1.1201",
  "upgrade-components-lib": "static-1.793",
  "utility-belt": "static-1.3070",
  "zustand": "static-1.92",
  "batch-promise": "static-1.2085",
  "customer-data-associations": "static-1.7879",
  "customer-data-property-utils": "static-1.8594",
  "customer-data-tracking": "static-1.7406",
  "framework-data-table": "static-2.12940",
  "object-builder-ui-client": "static-1.50210",
  "payments-enrollment-embed-lib": "static-1.24395",
  "stripe-embedded-components": "static-1.8331",
  "ui-addon-opt": "static-4.8969",
  "ai-components-ui-library": "static-1.10124",
  "customer-data-rte": "static-1.33996",
  "cv-backend-services": "static-1.1620",
  "file-manager-components": "static-1.24930",
  "growth-onboarding-confetti": "static-1.3591",
  "growth-onboarding-empty-states": "static-1.6624",
  "hubspot-prosemirror": "static-1.19394",
  "InboxConnectUtils": "static-4.15951",
  "payment-link-components": "static-1.24580",
  "payments-post-enroll-local-storage-lib": "static-1.5635",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39282",
  "react-colorpicker": "static-2.10744",
  "ui-addon-upgrades": "static-9.18606",
  "ui-addon-video-player": "static-1.9157",
  "user-context": "static-1.5593",
  "atom": "static-1.5608",
  "reference-resolvers": "static-1.8721",
  "calling-global-api": "static-1.66497",
  "calling-internal-common": "static-1.31857",
  "calling-lifecycle-internal": "static-1.67879",
  "calling-lifecycle-messages": "static-1.60171",
  "commerce-products-lib": "static-1.11087",
  "conditional-properties-service-client": "static-1.4148",
  "crm-index-visualization-core": "static-1.4847",
  "crm-links": "static-1.6862",
  "crm-pipelines-api-client-types": "static-1.4482",
  "customer-data-properties-shared-msw-handlers": "static-1.10328",
  "data-agent-utils": "static-1.1058",
  "data-token-picker": "static-1.17220",
  "external-options-client-types": "static-1.4476",
  "formula-editor": "static-1.15080",
  "google-libphonenumber": "static-1.52",
  "inbound-db-meta-service-client": "static-1.3808",
  "inbounddb-objects-service-types": "static-1.4552",
  "meetings-icalendar-utils-lib": "static-1.1170",
  "multi-currency-client-types": "static-1.4047",
  "pipeline-validation-client-types": "static-1.4320",
  "property-value-citations": "static-1.3859",
  "react-tinymce": "static-1.56369",
  "reference-resolvers-lite": "static-1.8648",
  "rich-text-lib": "static-1.20641",
  "smart-data-capture-core": "static-1.606",
  "tiered-pricing": "static-1.2385",
  "tinymce-config": "static-2.55495",
  "tinymce-plugins": "static-1.58609",
  "tinymce-themes": "static-1.57465",
  "topics-actions-lib": "static-1.728",
  "trellis-ext-i18n": "static-1.1476",
  "trial-components-library": "static-1.14478",
  "ui-addon-emoji-picker": "static-1.10399",
  "ui-addon-form-validation": "static-1.11352",
  "laboratory-lib": "static-3.7683",
  "seat-types-lib": "static-1.1166",
  "magpie-lib": "static-1.5958",
  "navigation-messaging": "static-1.8642",
  "ts-schema": "static-1.4431",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.11001",
  "hubspotter-http-shared-msw-handlers": "static-1.10999",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "amplitude-session-replay-browser": "static-1.79",
  "sequences-client-types-lib": "static-1.8725",
  "audio-components": "static-1.6649",
  "breeze-artifacts-sdk": "static-1.1194",
  "ContentUtils": "static-1.69614",
  "copilot-toolkit": "static-1.12261",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30145",
  "FileManagerImages": "static-1.38081",
  "html-to-image": "static-1.67",
  "immerable": "static-1.4679",
  "ui-universal-auth": "static-1.9855",
  "urlinator": "static-1.5052",
  "video-components": "static-1.14547",
  "video-data-lib": "static-1.36203",
  "video-embed": "static-1.37037",
  "hubspot-apollo-cache": "static-1.870",
  "trellis-migration-context": "static-1.113",
  "event-emitter": "static-1.1495",
  "fdsr-migration-layer": "static-1.548",
  "framework-builder-read-service-client": "static-1.4372",
  "bend-plugin-pulse": "static-1.704",
  "fast-json-patch": "static-1.76",
  "merchandise-lib": "static-1.289",
  "purchase-motions-components": "static-1.6717",
  "customer-data-reference-ui-components": "static-1.13711",
  "reporting-data": "static-1.69624",
  "tasks-actions-lib": "static-1.557",
  "growth-onboarding-feedback-components": "static-1.7120",
  "growth-onboarding-reliability": "static-1.5618",
  "marketplace-ui-apps-core": "static-1.19683",
  "onboarding-tours": "static-1.17478",
  "stripe-connect-js": "static-1.85",
  "chatspot-core": "static-1.24264",
  "content-assistance-lib": "static-1.8501",
  "draft-content-plugins": "static-1.29250",
  "draft-convert": "static-2.87",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22447",
  "breeze-engine-lib": "static-1.2379",
  "poll-commands": "static-1.4011",
  "video-components-external": "static-1.12545",
  "trellis-story-utils": "static-1.5031",
  "ui-addon-react-router-dom": "static-1.10063",
  "content-media-capture": "static-1.5883",
  "knowledge-content-types": "static-1.8767",
  "ui-business-units-lib": "static-1.9631",
  "ui-shepherd-react": "static-3.10822",
  "hub-http-contrib": "static-1.3565",
  "ui-addon-sales-email": "static-1.5742",
  "commerce-tours-lib": "static-1.6946",
  "getting-started-shared-tasks": "static-1.19656",
  "sales-checkout-service-client": "static-1.4057",
  "getting-started-shared-tasks-store": "static-1.18774",
  "onboarding-tours-utils": "static-1.1545",
  "calling-error-reporting": "static-1.31864",
  "shared-worker-versioning": "static-1.11575",
  "calling-usage-tracker": "static-1.7076",
  "conversations-skeleton-state": "static-1.7648",
  "voice-sms-access-library": "static-1.2606",
  "commerce-permissions": "static-1.1318",
  "products-iframe-lib": "static-1.9053",
  "products-ui-components-shared-msw-handlers": "static-1.11383",
  "crm-index-associations-lib": "static-1.6985",
  "sales-views-client-types": "static-1.4793",
  "location-customization-utils-lib": "static-1.10551",
  "data-agent-kit": "static-1.1045",
  "enrichment-settings-lib": "static-1.403",
  "fsm": "static-1.4296",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7339",
  "bark-lib": "static-1.17069",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6432",
  "react-codemirror": "static-1.11177",
  "tinymce": "static-5.11",
  "interframe": "static-3.5280",
  "tinymce-data": "static-1.41580",
  "layout-dnd-components": "static-1.13315",
  "layout-dnd-utils": "static-1.12290",
  "ui-brand-identity-lib": "static-1.17093",
  "NamespacedHubStyle": "static-2.9405",
  "embedded-academy-lib": "static-1.16190",
  "hubs-service-types": "static-1.1801",
  "navigation-components": "static-1.19315",
  "nest": "static-1.773",
  "nudge-client-utils": "static-1.3507",
  "purchase-motions-api": "static-1.6720",
  "signup-constants": "static-1.20109",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5418",
  "reactive-lib": "static-1.1257",
  "simple-logging-lib": "static-1.3582",
  "nav-meta": "static-1.30952",
  "breeze-engine-core": "static-1.1657",
  "cms-field-types": "static-1.5348",
  "content-icons-ui": "static-1.2519",
  "integrations-lib": "static-1.17557",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.419",
  "unified-auth-core-lib": "static-1.1651",
  "social-insights-client-types": "static-1.23038",
  "outpost": "static-1.4661",
  "persist-promise": "static-1.4242",
  "signup-ui-url-generator": "static-2.8570",
  "reporting-client-types": "static-1.2897",
  "developer-experience-shared-components": "static-1.11080",
  "immutable-less": "static-1.5183",
  "marketplace-ui-client-types": "static-1.18558",
  "marketplace-ui-common": "static-1.21151",
  "ui-addon-integrations-directory-panel": "static-2.8484",
  "ui-extensibility-client-types": "static-1.4453",
  "growth-data-modal": "static-1.6213",
  "growth-onboarding-next-action-utils": "static-1.3094",
  "onboarding-tours-client": "static-1.5693",
  "ui-shepherd-tracker": "static-1.8203",
  "ui-coaching-tips": "static-1.29638",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1357",
  "highlight.js": "static-1.92",
  "content-media-composition-data-lib": "static-1.13687",
  "content-media-compositions": "static-2.17694",
  "media-bridge-lib": "static-1.19726",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4964",
  "calling-orchestration-schema": "static-1.37383",
  "crm-record-cards-service-types": "static-1.3893",
  "highcharts": "static-8.117",
  "storybook-react": "static-1.46",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16767",
  "browser-eslint": "static-2.57",
  "ContentData": "static-1.69689",
  "layout-data-lib": "static-1.10616",
  "academy-common-lib": "static-1.15651",
  "nudge-custom-function-registry": "static-1.3264",
  "nudge-renderer-utils": "static-1.3583",
  "whisper-core-api": "static-1.7733",
  "flux-actions": "static-1.383",
  "integrations-error-boundary-lib": "static-1.14972",
  "integrations-tracking-lib": "static-1.6163",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4143",
  "oauth-service-types": "static-1.4671",
  "ai-settings-ui-library": "static-1.8683",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1803",
  "onboarding-data-sync-lib": "static-1.2919",
  "growth-onboarding-next-action-components": "static-1.3122",
  "user-context-client": "static-1.5042",
  "js-cookie": "static-1.18",
  "advanced-menus-core": "static-1.15907",
  "advanced-menus-lib": "static-1.12636",
  "ExportDialog": "static-6.10909",
  "ui-memberships-settings-lib": "static-1.35323",
  "academy-service-client": "static-1.4228",
  "croppie": "static-2.10",
  "final-form": "static-1.85",
  "SafeStorage": "static-1.4930",
  "trellis-ecosystem": "static-1.7936",
  "universal-page-editor-lib": "static-1.3555",
  "settings-ui-lib": "static-1.13067",
  "simple-data-table": "static-1.3933",
  "meetings-connect-utils-lib": "static-1.8154",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15906",
  "simple-menus-lib": "static-1.17423",
  "crm-record-cards-client": "static-1.221",
  "framework-data-schema-resolvers": "static-1.7429",
  "framework-data-schema-quick-fetch": "static-1.7334"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28916",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2087",
  "client-types": "/client-types/static-1.522",
  "crm_data": "/crm_data/static-4.93349",
  "data-fetching-client": "/data-fetching-client/static-1.10170",
  "emoji-mart": "/emoji-mart/static-3.9",
  "enviro": "/enviro/static-4.529",
  "foundations-components": "/foundations-components/static-1.8846",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1871",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6125",
  "hs-test-utils": "/hs-test-utils/static-1.8577",
  "hub-http": "/hub-http/static-1.6740",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.12024",
  "I18n": "/I18n/static-7.1723",
  "jasmine-runner": "/jasmine-runner/static-1.6993",
  "quartz": "/quartz/static-1.7753",
  "raven": "/raven/static-3.6435",
  "react-dlb": "/react-dlb/static-1.96",
  "react-stripe-js": "/react-stripe-js/static-1.123",
  "react-utils": "/react-utils/static-2.5714",
  "reselect": "/reselect/static-3.19",
  "stripe-js": "/stripe-js/static-1.122",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6161",
  "UIComponents": "/UIComponents/static-3.8970",
  "usage-tracker-public": "/usage-tracker-public/static-1.7688",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38164",
  "cssUtils": "/cssUtils/static-1.1158",
  "customer-data-objects": "/customer-data-objects/static-1.8249",
  "FireAlarmUi": "/FireAlarmUi/static-1.4923",
  "foundations-assets": "/foundations-assets/static-1.5424",
  "foundations-theming": "/foundations-theming/static-1.5036",
  "graphql": "/graphql/static-1.95",
  "hs-browser-apis": "/hs-browser-apis/static-1.16",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12331",
  "icons": "/icons/static-2.715",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3411",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.839",
  "property-translator": "/property-translator/static-1.5911",
  "quartz-config": "/quartz-config/static-1.1531",
  "quartz-core": "/quartz-core/static-1.6972",
  "quartz-i18n": "/quartz-i18n/static-1.1428",
  "quartz-routing": "/quartz-routing/static-1.1183",
  "quartz-tracking": "/quartz-tracking/static-1.1132",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17272",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.87",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "ReduxMessenger": "/ReduxMessenger/static-2.10907",
  "rpc-client-utils": "/rpc-client-utils/static-1.5201",
  "sanitize-text": "/sanitize-text/static-1.8692",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5290",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11682",
  "ui-images": "/ui-images/static-2.1295",
  "usage-tracker-core": "/usage-tracker-core/static-1.7727",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4030",
  "quartz-webpack": "/quartz-webpack/static-1.3977",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.831",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "crm_universal": "/crm_universal/static-1.22807",
  "customer-data-email": "/customer-data-email/static-1.18732",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10368",
  "dispatcher": "/dispatcher/static-1.150",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8458",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8293",
  "quick-fetch": "/quick-fetch/static-1.4265",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5115",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2752",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9959",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.120",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3253",
  "ui-fonts": "/ui-fonts/static-1.1286",
  "HeadJS": "/HeadJS/static-2.836",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3688",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.41",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.440",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4840",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6329",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5287",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20611",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19689",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11429",
  "crm-message-bus": "/crm-message-bus/static-1.44254",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13571",
  "customer-data-properties": "/customer-data-properties/static-1.53245",
  "growth-payments-core": "/growth-payments-core/static-1.26622",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9615",
  "usage-tracker": "/usage-tracker/static-1.7877",
  "usage-tracker-container": "/usage-tracker-container/static-1.7867",
  "sassPrefix": "/sassPrefix/static-1.422",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4188",
  "foundations-theming-base": "/foundations-theming-base/static-1.4021",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3519",
  "stylex": "/stylex/static-1.48",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.335",
  "hub-http-janus": "/hub-http-janus/static-1.919",
  "hubspotter-http": "/hubspotter-http/static-1.5011",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.618",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.710",
  "quartz-auth": "/quartz-auth/static-1.1428",
  "quartz-head": "/quartz-head/static-1.1418",
  "quartz-test": "/quartz-test/static-1.1428",
  "trellis-components": "/trellis-components/static-1.3272",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5563",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.237",
  "web-vitals": "/web-vitals/static-1.21",
  "immer": "/immer/static-1.107",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.611",
  "chirp-fetch": "/chirp-fetch/static-1.2435",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.5003",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5249",
  "sequences-lib": "/sequences-lib/static-1.8868",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5124",
  "FileManagerCore": "/FileManagerCore/static-1.40429",
  "FileManagerLib": "/FileManagerLib/static-1.40570",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5411",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.793",
  "timezone-utils": "/timezone-utils/static-2.5761",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "react-dnd-compat": "/react-dnd-compat/static-1.5145",
  "stylex-utils": "/stylex-utils/static-1.190",
  "trellis-theming": "/trellis-theming/static-1.1576",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.85",
  "avatar-components": "/avatar-components/static-1.3023",
  "crm-command-handler-types": "/crm-command-handler-types/static-1.192",
  "hs-resources": "/hs-resources/static-1.731",
  "onboarding-scopes": "/onboarding-scopes/static-1.6987",
  "pulse": "/pulse/static-1.1201",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.793",
  "utility-belt": "/utility-belt/static-1.3070",
  "zustand": "/zustand/static-1.92",
  "batch-promise": "/batch-promise/static-1.2085",
  "customer-data-associations": "/customer-data-associations/static-1.7879",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8594",
  "customer-data-tracking": "/customer-data-tracking/static-1.7406",
  "framework-data-table": "/framework-data-table/static-2.12940",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50210",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24395",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8331",
  "ui-addon-opt": "/ui-addon-opt/static-4.8969",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10124",
  "customer-data-rte": "/customer-data-rte/static-1.33996",
  "cv-backend-services": "/cv-backend-services/static-1.1620",
  "file-manager-components": "/file-manager-components/static-1.24930",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3591",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6624",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19394",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15951",
  "payment-link-components": "/payment-link-components/static-1.24580",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5635",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39282",
  "react-colorpicker": "/react-colorpicker/static-2.10744",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18606",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9157",
  "user-context": "/user-context/static-1.5593",
  "atom": "/atom/static-1.5608",
  "reference-resolvers": "/reference-resolvers/static-1.8721",
  "calling-global-api": "/calling-global-api/static-1.66497",
  "calling-internal-common": "/calling-internal-common/static-1.31857",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67879",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60171",
  "commerce-products-lib": "/commerce-products-lib/static-1.11087",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4148",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4847",
  "crm-links": "/crm-links/static-1.6862",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4482",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10328",
  "data-agent-utils": "/data-agent-utils/static-1.1058",
  "data-token-picker": "/data-token-picker/static-1.17220",
  "external-options-client-types": "/external-options-client-types/static-1.4476",
  "formula-editor": "/formula-editor/static-1.15080",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3808",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4552",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1170",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4047",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4320",
  "property-value-citations": "/property-value-citations/static-1.3859",
  "react-tinymce": "/react-tinymce/static-1.56369",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8648",
  "rich-text-lib": "/rich-text-lib/static-1.20641",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.606",
  "tiered-pricing": "/tiered-pricing/static-1.2385",
  "tinymce-config": "/tinymce-config/static-2.55495",
  "tinymce-plugins": "/tinymce-plugins/static-1.58609",
  "tinymce-themes": "/tinymce-themes/static-1.57465",
  "topics-actions-lib": "/topics-actions-lib/static-1.728",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1476",
  "trial-components-library": "/trial-components-library/static-1.14478",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10399",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "laboratory-lib": "/laboratory-lib/static-3.7683",
  "seat-types-lib": "/seat-types-lib/static-1.1166",
  "magpie-lib": "/magpie-lib/static-1.5958",
  "navigation-messaging": "/navigation-messaging/static-1.8642",
  "ts-schema": "/ts-schema/static-1.4431",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11001",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10999",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.79",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8725",
  "audio-components": "/audio-components/static-1.6649",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1194",
  "ContentUtils": "/ContentUtils/static-1.69614",
  "copilot-toolkit": "/copilot-toolkit/static-1.12261",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30145",
  "FileManagerImages": "/FileManagerImages/static-1.38081",
  "html-to-image": "/html-to-image/static-1.67",
  "immerable": "/immerable/static-1.4679",
  "ui-universal-auth": "/ui-universal-auth/static-1.9855",
  "urlinator": "/urlinator/static-1.5052",
  "video-components": "/video-components/static-1.14547",
  "video-data-lib": "/video-data-lib/static-1.36203",
  "video-embed": "/video-embed/static-1.37037",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.870",
  "trellis-migration-context": "/trellis-migration-context/static-1.113",
  "event-emitter": "/event-emitter/static-1.1495",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.548",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4372",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.704",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "merchandise-lib": "/merchandise-lib/static-1.289",
  "purchase-motions-components": "/purchase-motions-components/static-1.6717",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13711",
  "reporting-data": "/reporting-data/static-1.69624",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.557",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7120",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19683",
  "onboarding-tours": "/onboarding-tours/static-1.17478",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "chatspot-core": "/chatspot-core/static-1.24264",
  "content-assistance-lib": "/content-assistance-lib/static-1.8501",
  "draft-content-plugins": "/draft-content-plugins/static-1.29250",
  "draft-convert": "/draft-convert/static-2.87",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22447",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2379",
  "poll-commands": "/poll-commands/static-1.4011",
  "video-components-external": "/video-components-external/static-1.12545",
  "trellis-story-utils": "/trellis-story-utils/static-1.5031",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10063",
  "content-media-capture": "/content-media-capture/static-1.5883",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9631",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10822",
  "hub-http-contrib": "/hub-http-contrib/static-1.3565",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5742",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6946",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19656",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4057",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18774",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1545",
  "calling-error-reporting": "/calling-error-reporting/static-1.31864",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11575",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7076",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7648",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2606",
  "commerce-permissions": "/commerce-permissions/static-1.1318",
  "products-iframe-lib": "/products-iframe-lib/static-1.9053",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11383",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6985",
  "sales-views-client-types": "/sales-views-client-types/static-1.4793",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10551",
  "data-agent-kit": "/data-agent-kit/static-1.1045",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.403",
  "fsm": "/fsm/static-1.4296",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7339",
  "bark-lib": "/bark-lib/static-1.17069",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6432",
  "react-codemirror": "/react-codemirror/static-1.11177",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5280",
  "tinymce-data": "/tinymce-data/static-1.41580",
  "layout-dnd-components": "/layout-dnd-components/static-1.13315",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12290",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17093",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9405",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16190",
  "hubs-service-types": "/hubs-service-types/static-1.1801",
  "navigation-components": "/navigation-components/static-1.19315",
  "nest": "/nest/static-1.773",
  "nudge-client-utils": "/nudge-client-utils/static-1.3507",
  "purchase-motions-api": "/purchase-motions-api/static-1.6720",
  "signup-constants": "/signup-constants/static-1.20109",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5418",
  "reactive-lib": "/reactive-lib/static-1.1257",
  "simple-logging-lib": "/simple-logging-lib/static-1.3582",
  "nav-meta": "/nav-meta/static-1.30952",
  "breeze-engine-core": "/breeze-engine-core/static-1.1657",
  "cms-field-types": "/cms-field-types/static-1.5348",
  "content-icons-ui": "/content-icons-ui/static-1.2519",
  "integrations-lib": "/integrations-lib/static-1.17557",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.419",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1651",
  "social-insights-client-types": "/social-insights-client-types/static-1.23038",
  "outpost": "/outpost/static-1.4661",
  "persist-promise": "/persist-promise/static-1.4242",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8570",
  "reporting-client-types": "/reporting-client-types/static-1.2897",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11080",
  "immutable-less": "/immutable-less/static-1.5183",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18558",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21151",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8484",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4453",
  "growth-data-modal": "/growth-data-modal/static-1.6213",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3094",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5693",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8203",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29638",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1357",
  "highlight.js": "/highlight.js/static-1.92",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13687",
  "content-media-compositions": "/content-media-compositions/static-2.17694",
  "media-bridge-lib": "/media-bridge-lib/static-1.19726",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4964",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37383",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3893",
  "highcharts": "/highcharts/static-8.117",
  "storybook-react": "/storybook-react/static-1.46",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16767",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentData": "/ContentData/static-1.69689",
  "layout-data-lib": "/layout-data-lib/static-1.10616",
  "academy-common-lib": "/academy-common-lib/static-1.15651",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3264",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3583",
  "whisper-core-api": "/whisper-core-api/static-1.7733",
  "flux-actions": "/flux-actions/static-1.383",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14972",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6163",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4143",
  "oauth-service-types": "/oauth-service-types/static-1.4671",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8683",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1803",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2919",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3122",
  "user-context-client": "/user-context-client/static-1.5042",
  "js-cookie": "/js-cookie/static-1.18",
  "advanced-menus-core": "/advanced-menus-core/static-1.15907",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12636",
  "ExportDialog": "/ExportDialog/static-6.10909",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35323",
  "academy-service-client": "/academy-service-client/static-1.4228",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.85",
  "SafeStorage": "/SafeStorage/static-1.4930",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7936",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3555",
  "settings-ui-lib": "/settings-ui-lib/static-1.13067",
  "simple-data-table": "/simple-data-table/static-1.3933",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8154",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15906",
  "simple-menus-lib": "/simple-menus-lib/static-1.17423",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.221",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7429",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7334"
}
};
